'use strict';

module.exports = [function () {
     return {
        replace: true,
        scope: true,        
        template: require('./tableButtonGroupActionPerms.html')
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonGroupActionPerms.js
// module id = 376
// module chunks = 0